var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "m-pdf" },
    [
      _c("van-nav-bar", {
        attrs: { "safe-area-inset-top": "", "left-arrow": "" },
        on: {
          "click-left": function ($event) {
            return _vm.$router.go(-1)
          },
        },
      }),
      _c("div", {
        staticStyle: { width: "100%", height: "100%" },
        attrs: { id: "pdf-content" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }